import {FC, useEffect, useRef} from 'react'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../_metronic/layout/core'
import SchedulerExecuteLogsTable from './components/SchedulerExecuteLogsTable'
import SchedulerExecuteLogsFilter from './components/SchedulerExecuteLogsFilter'
import {SettingReferenceModel} from '../setting-reference/models/SettingReferenceModel'
import {useAppSelector} from '../../../setup/redux/hooks'
import {getAll, selectSettingReferenceList} from '../setting-reference/redux/SettingReferenceRedux'
import {useDispatch} from 'react-redux'
import {SettingReferenceStatus} from '../setting-reference/constants'

const SchedulerExecuteLogs: FC = () => {
  const intl = useIntl()
  const dispatch = useDispatch()
  const didRequest = useRef(false)
  const availableSettings: SettingReferenceModel[] = useAppSelector(selectSettingReferenceList)
  useEffect(() => {
    const getService = async () => {
      if (!didRequest.current) {
        dispatch(
          getAll({
            serviceId: 1,
            status: SettingReferenceStatus.ACTIVE,
          })
        )
      }

      return () => (didRequest.current = true)
    }

    getService()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return (
    <>
      <PageTitle breadcrumbs={[]}>
        {intl.formatMessage({id: 'SCHEDULER.LOGS.PAGE_TITLE'})}
      </PageTitle>
      <div className='mx-1 mb-3'>
        <div className='d-flex bg-light-warning rounded border-warning border border-dashed p-6'>
          <i className='bi bi-exclamation-circle-fill fs-2tx text-warning me-4'></i>
          <div className='d-flex flex-stack flex-grow-1'>
            <div className='fw-bold'>
              <div className='fs-6 text-gray-600'>
                {intl.formatMessage({id: 'SCHEDULER.LOGS.NOTICE'})}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='card mb-10'>
        <div className='card-header border-0 pt-6'>
          <div className='card-title'>
            <SchedulerExecuteLogsFilter settings={availableSettings} />
          </div>
        </div>
        <div className='card-body py-4'>
          <SchedulerExecuteLogsTable />
        </div>
      </div>
    </>
  )
}

export default SchedulerExecuteLogs
